import { render, staticRenderFns } from "./VisaAcknowledgePenaltyModal.vue?vue&type=template&id=6b3d0a11&"
import script from "./VisaAcknowledgePenaltyModal.vue?vue&type=script&lang=js&"
export * from "./VisaAcknowledgePenaltyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports